// Single source of truth for the "unassigned trip" definition on Bussplan, so
// the prominent "Utildelte turer (N)" counter and the filtered grid list can
// never diverge (one predicate, used by both). A trip counts as unassigned when
// it has neither an internal driver nor an external company assigned.
export function isUnassignedTrip(trip: any): boolean {
  return !!trip && !trip.driver_id && !trip.external_company;
}
